import Layout from '@/views/Layout';
import Transform from '@/views/Transform';

// 数据报表

export default {
  name: 'DataReport',
  path: '/data-report',
  meta: {
    icon: 'el-icon-document',
    label: '数据报表',
    isMenu: true,
  },
  component: Layout,
  children: [
    {
      name: 'DataReportMarketReport',
      path: 'market-report',
      meta: {
        label: '大盘数据报表',
        isMenu: true,
      },
      component: () => import('@/views/DataReport/MarketReport/Index'),
    },
    {
      name: 'DataReportAchieveReport',
      path: 'achieve-report',
      meta: {
        label: '我的业绩',
        isMenu: true,
        hiddenContentTitle: true,
      },
      component: () => import('@/views/DataReport/AchieveReport/Index'),
    },
    {
      name: 'DataReportClientReport',
      path: 'client-report',
      meta: {
        label: '新开户统计',
        isMenu: true,
      },
      component: () => import('@/views/DataReport/ClientReport/Index'),
    },
    {
      name: 'DataReportMediaReport',
      path: 'media-report',
      meta: {
        label: '媒体和广告位统计',
        isMenu: true,
      },
      component: () => import('@/views/DataReport/MediaReport/Index'),
    },
    {
      name: 'DataReportStopCostReport',
      path: 'stop-cost-report',
      meta: {
        label: '停投统计',
        isMenu: true,
      },
      component: () => import('@/views/DataReport/StopCostReport/Index'),
    },
    {
      name: 'DataReportSaleReport',
      path: 'sale-report',
      meta: {
        label: '销售新户统计',
        isMenu: true,
        redirect: '/sales3/index',
      },
      component: Transform,
    },
    {
      name: 'DataReportTotalFlowReport',
      path: 'total-flow-report',
      meta: {
        label: '销售总流水报表',
        isMenu: true,
        redirect: '/sales/influence',
      },
      component: Transform,
    },
    {
      name: 'DataReportAdvertiserDailyConsumptionData',
      path: 'advertiser-daily-consumption-data',
      meta: {
        label: '广告主分日消耗数据',
        isMenu: true,
        redirect: '/sales4/customerDayData',
      },
      component: Transform,
    },
    {
      name: 'DataReportAdvertiserDailyConsumptionDataSummary',
      path: 'advertiser-daily-consumption-data-summary',
      meta: {
        label: '广告主分日消耗数据汇总',
        isMenu: true,
        redirect: '/sales4/customerTotalData',
      },
      component: Transform,
    },
    {
      name: 'DataReportAgentDailyConsumptionData',
      path: 'agent-daily-consumption-data',
      meta: {
        label: '代理商分日消耗数据',
        isMenu: true,
        redirect: '/sales4/agentDayData',
      },
      component: Transform,
    },
    {
      name: 'DataReportIndustryConsumptionData',
      path: 'industry-consumption-data',
      meta: {
        label: '行业消耗数据',
        isMenu: true,
        redirect: '/sales4/categoryData',
      },
      component: Transform,
    },
    {
      name: 'DataReportAgentConsumptionDataSummary',
      path: 'agent-consumption-data-summary',
      meta: {
        label: '代理商消费数据汇总',
        isMenu: true,
        redirect: '/sales4/agentTotalData',
      },
      component: Transform,
    },
    {
      name: 'DirectSaleReportDataView',
      path: 'direct-data-view',
      meta: {
        label: '直客业绩',
        isMenu: true,
      },
      component: () => import('@/views/DirectSaleReport/DataView/Index'),
    },
    {
      name: 'DirectSaleReportDetail',
      path: 'direct-detail',
      meta: {
        label: '直客销售报表',
        isMenu: true,
      },
      component: () => import('@/views/DirectSaleReport/Detail/Index'),
    },
    {
      name: 'ChannelReportDataOverview',
      path: 'data-overview',
      meta: {
        label: '渠道数据报表',
        isMenu: true,
        hiddenContentTitle: true,
      },
      component: () => import('@/views/ChannelReport/DataOverview/Index'),
      redirect: '/channel-report/data-overview/dashboard',
      children: [
        {
          name: 'ChannelReportDataOverviewDashboard',
          path: '/channel-report/data-overview/dashboard',
          meta: {
            label: '大盘数据',
            isMenu: false,
            hiddenContentTitle: true,
          },
          component: () =>
            import('@/views/ChannelReport/DataOverviewV2/index.vue'),
        },
      ],
    },
    {
      name: 'ProductReportData',
      path: 'data',
      meta: {
        label: '产品报表',
        isMenu: true,
      },
      component: () => import('@/views/ProductReport/ProductReport/Index'),
    },
    {
      name: '聚合报表',
      path: 'aggregation',
      meta: {
        label: '总数据报表',
        isMenu: true,
      },
      component: () => import('@/views/AggregationReport/AggregationReport/Index'),
    },
    {
      name: 'DirectCustomerReport',
      path: 'direct-customer',
      meta: {
        label: '直客业绩报表',
        isMenu: true,
      },
      component: () => import('@/views/DirectCustomerReport/DirectCustomerReport/Index'),
    },
    {
      name: 'KA报表',
      path: 'ka',
      meta: {
        label: 'KA报表',
        isMenu: true,
      },
      component: () => import('@/views/KAReport/KAReport/Index'),
    },
    // {
    //   name: '产品系报表',
    //   path: 'productSeries',
    //   meta: {
    //     label: '产品系报表',
    //     isMenu: true,
    //   },
    //   component: () => import('@/views/ProductSeriesReport/ProductSeriesReport/Index'),
    // },
    {
      name: 'ProductReportExactProduct',
      path: 'exact-product',
      meta: {
        label: '精确查询产品',
        isMenu: true,
      },
      component: () => import('@/views/ProductReport/ExactProductSearch/Index'),
    },
    {
      name: 'ProductReportMarketFluctuations',
      path: 'market-fluctuations',
      meta: {
        label: '大盘波动',
        isMenu: true,
      },
      component: () => import('@/views/MarketFluctuations/'),
    },
  ],
};
